// extracted by mini-css-extract-plugin
export default {"container":"paper-module__container--PTTbk","level":"paper-module__level--2cg7x"};